export const whiteList = ['/login', '/error/401', 'error/404', '/KiliMall/goodsEditUpload', '/KiliMall/goodsBndgift', '/KiliMall/goodsList', '/KiliMall/brandCheck', '/KiliMall/brandApply', '/KiliMall/drafts', '/KiliMall/categoryVue', '/KiliMall/merchantList', '/KiliMall/storeList', '/kiliMall/qualityScore', '/home', '/KiliMall/ReviewMangmen', '/ActiveBackstage/signUp', '/ActiveBackstage/process', '/KiliMall/BusinessReport', '/forgotPassword', '/KiliMall/afterList',
  '/KiliMall/billManage/exchangeRateList',
  '/KiliMall/billManage/reconciliationList',
  '/KiliMall/billManage/accountReport',
  '/KiliMall/billManage/billReport',
  '/KiliMall/billManage/settlementList',
  '/Seller/billManage/accountReport',
  '/Seller/billManage/billReport',
  '/KiliMall/afterSale/replacementPlat',
  '/KiliMall/afterSale/platformAfterList',
  '/KiliMall/afterSale/applyForUser',
  '/KiliMall/afterSale/afterRefundList',
  '/KiliMall/admin/afterSale/afterType', '/KiliMall/admin/afterSale/afterQualityCheck', "/KiliMall/admin/afterSale/afterRule", "/KiliMall/admin/afterSale/afterDeliveryTime",
  '/KiliMall/admin/afterSale/afterReasons',
  '/KiliMall/admin/afterSale/afterReasonGroup',
  '/KiliMall/admin/afterSale/afterReasonSet',
  '/KiliMall/admin/afterSale/afterReasonBind',
  '/KiliMall/restockPlanning/platformRestock',
  '/KiliMall/restockPlanning/addRestockPlan',
  '/KiliMall/restockPlanning/invitedRestock',
  '/KiliMall/restockPlanning/viewRestock',
  '/KiliMall/restockReplenishment/replenishmentList',
  '/KiliMall/restockReplenishment/checked',
  '/KiliMall/restockReplenishment/closed',
  '/KiliMall/restockReplenishment/create',
  '/KiliMall/restockReplenishment/proposalView',
  '/KiliMall/restockReplenishment/pendingReplenishment',
  '/KiliMall/settleAccounts/brokerageImport',
]


export const whiteNames = [
  'HelpCenter',
  'HelpDetail'
]
